import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    globalVar: '这是全局变量'
  },
  getters: {
    globalVar: state => state.globalVar
  },
  mutations: {
    setGlobalVar(state, value) {
      state.globalVar = value;
    }
  },
  actions: {
  },
  modules: {
  }
})
